import { STICKY_CTA_BAR_VIEW } from './types';

export const triggerStickyCtaBarIsViewed = () => ({
  type: STICKY_CTA_BAR_VIEW,
});
